/*
    Regular order is: SELF > TOP > FIRST.
    For donations > 10, if TOP is by the same person as SELF or FIRST then order is: TOP > SELF > FIRST
    For donations <= 10, if SELF is by the same person as FIRST then order is: FIRST > SELF
*/
export function formatFeatured(contributions, totalContributions) {
  let formattedList = [];

  if (contributions.length === 0) {
    return formattedList;
  }

  const first = contributions.find((c) => c.badge.toUpperCase() === 'FIRST');
  const top = contributions.find((c) => c.badge.toUpperCase() === 'TOP');
  const selfItem = contributions.find((c) => c.badge.toUpperCase() === 'SELF');

  if (
    totalContributions > 10 &&
    (top.contributor_id === first.contributor_id ||
      top.contributor_id === selfItem?.contributor_id)
  ) {
    if (top) {
      formattedList.push(top);
    }
    if (selfItem) {
      formattedList.push(selfItem);
    }
    if (first) {
      formattedList.push(first);
    }
  } else if (first.contributor_id === selfItem?.contributor_id) {
    if (first) {
      formattedList.push(first);
    }
    if (selfItem) {
      formattedList.push(selfItem);
    }
  } else {
    if (selfItem) {
      formattedList.push(selfItem);
    }
    if (top) {
      formattedList.push(top);
    }
    if (first) {
      formattedList.push(first);
    }
  }

  return formattedList;
}
